export default __webpack_public_path__ + "static/media/monitor-contest-ranking.38d4cd06.mp4";